<script>

</script>
<div class="row">
    <div class="col-3 col-lg-5">
        <div class="linea"></div>
    </div>
    <div class="col-6 col-lg-2" style="text-align: center;">
        <h1>Contacto</h1>
    </div>
    <div class="col-3 col-lg-5">
        <div class="linea"></div>
    </div>
</div>
<footer class="margin-20">
    <div class="row">
        <div class="col-12 col-lg-6"  style="text-align: center;">
            <ul>
                <li class="none-list"><h5 class="footer-leyend">Teléfono: +54 9 11 3118-2764</h5></li>
              </ul>
        </div>
        <div class="col-12 col-lg-6"  style="text-align: center;">
    <ul>
        <li class="none-list">
            <h5 class="footer-leyend">
                Mail: 
                <a href="mailto:administracion@icema.com.ar">administracion@icema.com.ar</a>
            </h5>
        </li>
    </ul>
        </div>
    </div>
</footer>

<style>
    .none-list{
        list-style:none;
    }
    .margin-20{
        margin-left:1vw;
        width: 95vw;
    }
</style>